import { useEffect, useState } from "react";

const PHONE_MAX = 860;
const TABLET_MAX = 1180;

function queryMatches(query) {
  if (typeof window.matchMedia !== "function") {
    return false;
  }

  return window.matchMedia(query)?.matches ?? false;
}

function readViewportTier() {
  if (typeof window === "undefined") {
    return "desktop";
  }

  if (queryMatches(`(max-width: ${PHONE_MAX}px)`)) {
    return "phone";
  }

  if (queryMatches(`(max-width: ${TABLET_MAX}px)`)) {
    return "tablet";
  }

  return "desktop";
}

/** Phone ≤860px, tablet ≤1180px, else desktop. Matches werkplan + CutSimulator breakpoints. */
export function useCompactViewport() {
  const [tier, setTier] = useState(readViewportTier);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return undefined;

    const phoneQuery = window.matchMedia(`(max-width: ${PHONE_MAX}px)`);
    const tabletQuery = window.matchMedia(`(max-width: ${TABLET_MAX}px)`);

    if (!phoneQuery?.addEventListener || !tabletQuery?.addEventListener) {
      return undefined;
    }

    const update = () => setTier(readViewportTier());

    update();
    phoneQuery.addEventListener("change", update);
    tabletQuery.addEventListener("change", update);

    return () => {
      phoneQuery.removeEventListener("change", update);
      tabletQuery.removeEventListener("change", update);
    };
  }, []);

  return {
    tier,
    isPhone: tier === "phone",
    isTablet: tier === "tablet",
    isCompact: tier === "phone" || tier === "tablet",
  };
}
